'use client'

import { useEffect } from 'react'
import { useUser } from '@auth0/nextjs-auth0'
import { Role } from '@phoenix-web/utils/journey'
import { identify } from '@/app/_wrappers/AnalyticsLoader'
import { appziIdentity } from '@/app/_wrappers/AppziLoader'
import { KnockUser } from '@/lib/auth-utils'

/**
 * This component sets the appzi identity on the client side
 */

export default function OnClientUserLoad() {
  const { user, isLoading } = useUser()
  const { account_id = null, roles = [] } = (user as KnockUser) || {}

  // Set the default role based on the user's roles, to be used in appzi identity
  let defaultRole: string
  if ((roles as string[]).includes(Role.LENDER) || (roles as string[]).includes(Role.MORTGAGE_BROKER)) {
    defaultRole = 'lender'
  } else if ((roles as string[]).includes(Role.AGENT)) {
    defaultRole = 'agent'
  }

  useEffect(() => {
    if (!isLoading && account_id) {
      appziIdentity(account_id as string, defaultRole)
      identify({ accountId: Number(account_id) })
    }
    // ToDo: Do we need to handle a logout? or is that not necessary as the account id would be set on next login
  }, [account_id, isLoading])

  return null
}
